export default __webpack_public_path__ + "static/media/icons-change-green-24-px.561776bd.svg";